import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';

import { Auth } from '../auth';
import { materialUITheme } from '../theme';
import { AppContainer } from './app-container';

function App({ modals }) {
  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={createTheme(adaptV4Theme(materialUITheme))}>
          <Auth>
            <AppContainer modals={modals} />
          </Auth>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}

export default App;
